import f from "./funcs";
import $ from "jquery";
import Api from "classes/api/Api";
import Loader from "classes/Loader";
import "plugins/sendform";
import "plugins/jquery.cookie";
import "plugins/password";
import "underscore";
import "marionette";
import "backbone.className";

window.f = f;

class LoginPage {
    constructor() {
        this.ui = {};

        this.ui.$logo = $(".form-wrap, .logo");
        this.ui.$form = $(".form");
        this.ui.$error_placeholder = $(".error-wrap");
        this.ui.$remember = $(".-remember");

        this.initNoAutoFill();
        this.initDeviceType();

        this.ui.$form.sendForm(this.onResponse.bind(this), this.validateForm.bind(this));

        let brow = f.aboutBrow();
        $("html").addClass(brow.brow);
        if ( brow.brow != "Internet Explorer" ) {
            this.ui.$form.slideDown(200);
        }

        this.loader = new Loader({
            box: "body",
            width: 150
        });

        $(window).on("popstate", () => {
            // не запирваемся с роутингом (всего 2 url: "/login", "/")
            location.reload();
        });
    }

    initNoAutoFill() {

        // вырубаем autofill для логина и пароля
        this.ui.$login = $("<input type='text' name='login' placeholder='login' autocomplete='off' autofocus/>")
            .appendTo($(".line-login"));
        this.ui.$password = $("<input name='password' placeholder='password' autocomplete='off'/>")
            .appendTo($(".line-password"));

        this.ui.$password.password();
        this.rememberedLogin = localStorage.getItem("login-form-login");

        if ( this.rememberedLogin ) {
            this.ui.$login.val(this.rememberedLogin);
            this.ui.$remember.prop("checked", true);
        }
        else {
            this.ui.$remember.prop("checked", false);
        }
    }

    initDeviceType() {
        let $deviceType = this.ui.$form.find("input[name=\"deviceType\"]");
        let deviceId = $.cookie("deviceId");
        let aboutBrow = f.aboutBrow();

        if ( !deviceId ) {
            deviceId = Date.now () + "" + Math.round(Math.random() * 100000000);
            $.cookie("deviceId", deviceId);
        }

        $deviceType.val(aboutBrow.isMobile ? "mobile" : "desktop");
    }

    validateForm(data) {
        data = data || {};

        if ( !data.login || !data.password ) {
            return "{\"error\":\"bad_auth\"}";
        }

        if ( this.ui.$remember.prop("checked") ) {
            this.rememberedLogin = localStorage.setItem("login-form-login", this.ui.$login.val());
        }
        else {
            this.rememberedLogin = "";
            localStorage.removeItem("login-form-login");
        }

        return true;
    }

    onResponse(resp) {
        try {
            resp = $.parseJSON(resp);
        } catch (e) {
            resp = {};
        }

        let captchaImage = resp && resp.data && resp.data.captchaImage;

        if ( captchaImage ) {
            this.showCaptcha(captchaImage);
        }

        let result = resp.result || {};
        $.cookie("token", result.token || "testToken");
        window.localStorage.setItem("token",result.token);
        $.cookie("lang", result.lang);
        window.lang = result.lang;

        if ( resp.type == "error" && resp.code ) {
            // Тут нету доступа к langDicrionary,
            // поэтому пока ингорим правила no-cyrillic-string
            // TODO: lang

            if ( "No such user:" === resp.code.substr(0, "No such user:".length) ) {
                // eslint-disable-next-line no-cyrillic-string/no-cyrillic-string
                this.ui.$error_placeholder.text("Пользователя с таким именем не существует").show();
            }

            else if ( "Duplicate login from the same device type" === resp.code.substr(0, "Duplicate login from the same device type".length) ) {
                // eslint-disable-next-line no-cyrillic-string/no-cyrillic-string
                this.ui.$error_placeholder.text("Невозможно осуществить повторный вход").show();
            }
            else if ( "wrong_credential" === resp.code.substr(0, "wrong_credential".length) ) {
                // eslint-disable-next-line no-cyrillic-string/no-cyrillic-string
                this.ui.$error_placeholder.text("Неверный пароль").show();
            }
            else if ( resp.code == "exists_another_devices" ) {
                this.showKickMessage();
            }
            else {
                alert(resp.code);
            }

            return;
        }

        if ( !resp.error && resp.type != "error" ) {
            this.ui.$login.removeClass("error");
            this.ui.$password.removeClass("error");

            //this.loader.start();
            //$("body").addClass("loading");

            let onLoginCalled = false;
            this.ui.$logo.animate({
                top: "-1000px"
            }, () => {
                if ( onLoginCalled ) {
                    return;
                }
                onLoginCalled = true;
                this.onLogin(resp);
            });

        } else {
            this.ui.$login.addClass("error");
            this.ui.$password.addClass("error");
        }
    }

    onLogin() {
        $(".form-wrap, .if-ie").remove();

        Api.request({
            entity: "user",
            method: "getCurrentUser"
        }, (err, user) => {
            if ( err ) {
                location.href = "/";
            }
            $.cookie("user", JSON.stringify(user));

            this.showMain();
        });
    }

    showCaptcha(image) {
        let self = this;

        let $captcha = $(".captcha");

        this.setCaptchaImage($captcha, image);

        let $refreshButton = $captcha.find(".updateButtonReally");

        $refreshButton.off("click");
        $refreshButton.click(function(e) {
            e.preventDefault();

            let login = $(".line.line-login input").val();

            $.ajax({
                method: "POST",
                url: "/api/captcha/generate",
                data: {
                    login
                },
                success(response) {
                    console.log("CAPTCHA RESPONSE arguments", arguments);
                    let image = response && response.result && response.result.data && response.result.data.captchaImage;
                    self.setCaptchaImage($captcha, image);
                },
                error() {
                    console.error("failed to update captcha", arguments);
                }
            });
            console.log("refresh captcha");
        });

        $captcha.show();

        $(".form").css("height", "455px");
    }

    setCaptchaImage($captcha, image) {
        let $imageContainer = $captcha.find(".imageContainer");
        $imageContainer.html(image);
    }

    showMain() {
        window.location.href = "/";
    }

    // 2 пользователя не могут сидеть под одной учеткой
    // поэтому, если в ситеме под этой учеткой уже кто-то сидит
    // то его надо выкинуть.
    // тот кто сейчас входит должен решить выкинуть ли пользователя,
    // или не входить в систему
    showKickMessage() {
        require([
            "classes/lang/init"
        ], (langDictionary) => {
            f.lang = langDictionary.get.bind(langDictionary);

            this.createKickBody();
        });
    }

    createKickBody() {
        let $kickBody = $(".kick-body");

        if ( $kickBody.length ) {

            // setTimeout нужен, чтобы показать анимацию
            setTimeout(() => {
                $kickBody.removeClass("closed");
            });

            return $kickBody;
        }

        const kickText = f.lang("confirm_kick_another_user");
        const useAnotherLoginText = f.lang("user_another_login");
        const continueKickText = f.lang("continue_kick");

        $kickBody = $(`
                            <div class='kick-body closed'>
                                ${ kickText }

                                <div class='button kick-user-another-login'>
                                    ${useAnotherLoginText}
                                </div>

                                <div class='button kick-user-continue'>
                                    ${continueKickText}
                                </div>

                                <input name='kickAnother' hidden/>
                            </div>
                        `.trim());
        $kickBody.appendTo(".form");

        $kickBody.find(".kick-user-another-login")
            .on("click", () => {
                $kickBody.addClass("closed");
            });

        $kickBody.find(".kick-user-continue")
            .on("click", () => {
                this.onClickKickUser();
            });

        // setTimeout нужен, чтобы показать анимацию
        setTimeout(() => {
            $kickBody.removeClass("closed");
        });

        return $kickBody;
    }

    onClickKickUser() {
        $("[name='kickAnother']").val("1");
        $("form").submit();
    }
}

window.loginPage = new LoginPage();
